import { Card, Form, Radio, Row, Col, Typography } from "antd";
import React from "react";
import { DislikeOutlined, LikeOutlined } from "@ant-design/icons";

const Language = ({ psych = false, setLanguage }) => {
  const languageFields = [
    {
      label: "Repeat Test 1",
      sequence: "I only know that John is the one to help today",
      value: "language_1",
    },
    {
      label: "Repeat Test 2",
      sequence:
        "The cat always hid under the couch when the dogs were in the room",
      value: "language_2",
    },
    {
      label: "Fluency Test",
      sequence:
        "Name the maximum number of words in one minute that begin with the letter F",
      value: "language_3",
    },
  ];

  const handleChange = (value, fieldValue) => {
    setLanguage((prev) => ({
      ...prev,
      [fieldValue]: value,
    }));
  };

  return (
    <Row
      className="language-grid"
      align="middle"
      justify="center"
      gutter={[16, 16]}
      style={{
        width: "100%",
        maxWidth: "100%",
        margin: 0,
      }}
    >
      {languageFields.map((field) => (
        <Col
          key={field.value}
          className="language-card-col"
          xs={24}
          sm={24}
          md={12}
          lg={12}
        >
          <Card
            className="language-card"
            bordered={false}
            styles={{
              body: {
                width: "100%",
                boxSizing: "border-box",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              },
            }}
            style={{
              width: "100%",
              maxWidth: "100%",
              textAlign: "center",
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Typography style={{ width: "100%", textAlign: "center" }}>
              <Typography.Text strong className="language-label">
                {field.label}
              </Typography.Text>
              <Typography.Text className="language-sequence-text">
                {field.sequence}
              </Typography.Text>
            </Typography>

            <Form.Item
              name={
                psych === true
                  ? ["moca", "language_data", field.value]
                  : ["language_data", field.value]
              }
              style={{ width: "100%", marginBottom: 0, marginTop: 12 }}
            >
              <Radio.Group
                className="language-yesno-group"
                style={{ width: "100%" }}
                onChange={(e) => handleChange(e?.target?.value, field.value)}
              >
                <Row justify="center" gutter={[8, 0]}>
                  <Col>
                    <Radio.Button value="yes" className="like-btn">
                      <LikeOutlined />
                    </Radio.Button>
                  </Col>
                  <Col>
                    <Radio.Button value="no" className="dislike-btn">
                      <DislikeOutlined />
                    </Radio.Button>
                  </Col>
                </Row>
              </Radio.Group>
            </Form.Item>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Language;
